import { withReact } from 'slate-react';
import { withHistory } from 'slate-history';
import { EditorPlugin } from '../types';
import { withLinks } from './withInlines';
import { withTables } from './withTabels';
import { withNormalization } from './withNormalization';

export const plugins: EditorPlugin[] = [withReact, withLinks, withTables, withNormalization, withHistory];
